// extracted by mini-css-extract-plugin
export default {"icon":"ChromeAdblock_icon","title":"ChromeAdblock_title","subtitle":"ChromeAdblock_subtitle","button":"ChromeAdblock_button"};